import React from 'react';
import { Switch, Flex, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import Theme from '../../../styles/Theme/Theme';
import { Text } from '@synergy/atomics_and_hooks';

const SwitchWrapper = styled(Flex)`
    margin-top: ${Theme.spacing['s05']};

    .ant-switch {
        background-color: ${Theme.color['coolgray-6']};
        min-width: 28px;
        height: 16px;
        line-height: 16px;

        .ant-switch-handle {
            width: 12px;
            height: 12px;
            top: 2px;
        }

        &.ant-switch-checked .ant-switch-handle {
            inset-inline-start: calc(100% - 14px);
        }

        &.ant-switch-checked {
            background-color: ${Theme.color['blue-4']};
        }
    }

    .info-icon {
        color: ${Theme.color['coolgray-6']};
        font-size: 14px;
        cursor: pointer;
        
        &:hover {
            color: ${Theme.color['blue-4']};
        }
    }
`;

/**
 * FilterSwitch - A small labeled toggle switch for filter options.
 *
 * @param {boolean}  checked   - Whether the switch is on
 * @param {Function} onChange  - Callback when toggled: (checked: boolean) => void
 * @param {string}   label     - Text displayed next to the switch
 * @param {string}   tooltip   - Optional tooltip text shown next to the label via an (i) icon
 */
export const FilterSwitch = ({ checked, onChange, label, tooltip }) => {
    return (
        <SwitchWrapper align="center" gap={8}>
            <Switch checked={checked} onChange={onChange} />
            <Text textcolor='coolgray-12' textsize='text_sm' textweight='regular'>
                {label}
            </Text>
            {tooltip && (
                <Tooltip title={tooltip} color='white' placement="top">
                    <InfoCircleOutlined className="info-icon" />
                </Tooltip>
            )}
        </SwitchWrapper>
    );
};
